import {
  Button,
  ForwardIcon,
  List,
  ResourceSectionCard,
  Stack,
} from '@all-manager/design-system-v2';
import type { DisplayedSubjectQuote } from '../../../../../types';
import PendingQuoteRow from '../../PendingQuoteRow/PendingQuoteRow';
import { usePendingQuotesSection } from './usePendingQuotesSection';

type Props = {
  quotes: DisplayedSubjectQuote[];
  onNavigateToQuotes: () => void;
};

export default function PendingQuotesSection(props: Props) {
  const { rows } = usePendingQuotesSection(props);

  if (rows.length === 0) {
    return null;
  }

  return (
    <ResourceSectionCard
      variant="documents"
      title="Devis en attente"
      count={rows.length}
      isLoading={false}
      isEmpty={false}
      emptyLabel="Aucun devis en attente"
      data-testid="pending-quotes-section"
    >
      <Stack spacing={1}>
        <List disablePadding aria-label="Devis en attente de décision">
          {rows.map((row) => (
            <PendingQuoteRow key={row.id} row={row} onClick={props.onNavigateToQuotes} />
          ))}
        </List>

        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="text"
            size="small"
            color="default"
            onClick={props.onNavigateToQuotes}
            endIcon={<ForwardIcon fontSize="small" />}
          >
            Voir les devis
          </Button>
        </Stack>
      </Stack>
    </ResourceSectionCard>
  );
}
